import { render } from "./CreditPage.vue?vue&type=template&id=208b15a0&scoped=true"
import script from "./CreditPage.vue?vue&type=script&lang=js"
export * from "./CreditPage.vue?vue&type=script&lang=js"

import "./CreditPage.vue?vue&type=style&index=0&id=208b15a0&scoped=true&lang=css"
import "./CreditPage.vue?vue&type=style&index=1&id=208b15a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-208b15a0"]])

export default __exports__